import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { addAssetsComponent } from '@frontend/formEngine/readForm/readFormComponents';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { ProcessActivityReadContext } from '../../../carePath/process/processActivity/processActivityRead/processActivityReadContext';

export function OsasEvaluationRead() {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getComponents()} />;

    function getComponents(): ComponentsMap {
        const map: ComponentsMap = new Map();
        addAssetsComponent<OsasEvaluationData>(readSections, map);

        return map;
    }
}
